export const helpNumbers = {
    // syf numbers
    general: '1 (844) 373-4960',
    fraud: '1 (866) 834-3206',
    bankruptcy: '1 (800) 552-5239'
};
